/* 
    Importing Dependencies
*/
import * as service from "../../Service/Service";

export default {
  name: "Search",

  data: () => ({
    isLoading: false,
    ProvinceCityList: [],
    provincesList: [],
    cityList: [],
    selectedProvince: "",
    selectedCity: "",
    details: [],
    filteredProvinceDetails: [],
    headers: [
      {
        text: "BRANCH NAME",
        sortable: true,
        value: "BRANCH NAME"
      },
      { text: "Status", value: "Status" }
    ],
    snackbar: {
      isActive: false,
      text: "",
      color: "",
      timeout: 2000
    },
    search: "",
    isHubDetails: false,
    hubDetails: {}
  }),

  async mounted() {
    await this.GetprovinceAndCity();
  },

  methods: {
    async GetprovinceAndCity() {
      let context = this;
      this.isLoading = true;
      let result = await service.GetProvinceAndCity();
      if (result.error == false) {
        this.ProvinceCityList = result.data;
        context.provincesList = result.data.map(x => x.ProvinceName);
        //
      } else {
        this.snackbar.isActive = true;
        this.snackbar.text = "Something went wrong, please try again";
        this.snackbar.color = "warning";
      }
      this.isLoading = false;
    },

    async GetBranchDetails() {
      this.isLoading = true;
      let result = await service.GetBranchDetails(
        this.selectedProvince,
        this.selectedCity
      );
      if (!result.error) {
        this.details = result.data;
        console.log(this.details);

        //this.filteredProvinceDetails = result.data;
      } else {
        this.snackbar.isActive = true;
        this.snackbar.text = "Something went wrong, please try again";
        this.snackbar.color = "warning";
      }
      this.isLoading = false;
    },

    FilteredCityList() {
      let cities = this.ProvinceCityList.filter(
        x => x.ProvinceName == this.selectedProvince
      )[0].City;

      if (cities.length == 0) {
        return false;
      } else {
        this.cityList = cities;
      }
    }
  }
};
